// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfe_a bhy_bk bhy_bl bhy_bo","SwipeLeftToClose--animating":"bfe_b"};